export const nearbyDestinations = {
  "Tirana": ["Prishtina", "Milan", "Vienna"],
  "Prishtina": ["Tirana", "Vienna", "Milan"],
  "Dortmund": ["Stuttgart", "Memmingen", "Basel"],
  "Memmingen": ["Stuttgart", "Dortmund", "Zurich"],
  "Stuttgart": ["Memmingen", "Dortmund", "Zurich"],
  "Zurich": ["Basel", "Geneva", "Stuttgart"],
  "Basel": ["Zurich", "Geneva", "Stuttgart"],
  "Geneva": ["Zurich", "Basel", "Milan"],
  "Vienna": ["Milan", "Tirana", "Prishtina"],
  "Milan": ["Tirana", "Vienna", "Geneva"],
  "London": ["Geneva", "Basel", "Zurich"],
  "Rome": ["Milan", "Vienna", "Tirana"]
};

export const countryToCityMapping = {
  "Albania": "Tirana",
  "Kosovo": "Prishtina",
  "Republic of Kosovo": "Prishtina",
  "Germany": "Dortmund",
  "Switzerland": "Zurich",
  "Austria": "Vienna",
  "Italy": "Milan",
  "United Kingdom": "London"
};

export const DEFAULT_CITY = "Prishtina"; 